'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxConnect = require('redux-connect');

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

var _reactRedux = require('react-redux');

var _statistics = require('redux/modules/statistics');

var statisticsActions = _interopRequireWildcard(_statistics);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _statistics2 = require('selectors/statistics');

var _Panel = require('components/Panel');

var _Panel2 = _interopRequireDefault(_Panel);

var _DevicesChart = require('components/Statistics/DevicesChart/DevicesChart');

var _DevicesChart2 = _interopRequireDefault(_DevicesChart);

var _StatisticsRecipientProjectsList = require('containers/Statistics/StatisticsRecipientProjectsList/StatisticsRecipientProjectsList');

var _StatisticsRecipientProjectsList2 = _interopRequireDefault(_StatisticsRecipientProjectsList);

var _PlayStatsChart = require('components/Statistics/PlayStatsChart/PlayStatsChart');

var _PlayStatsChart2 = _interopRequireDefault(_PlayStatsChart);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./RecipientStatisticsOverall.scss');

var RecipientStatisticsOverall = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch,
        recipientId = _ref.params.recipientId;
    return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadRecipientOverallStats({ userId: recipientId })).promise);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    endDate: state.statistics.endDate,
    globalStatsData: (0, _statistics2.getRecipientGlobalData)(state),
    playStatsData: (0, _statistics2.getRecipientPlayStats)(state),
    projects: (0, _statistics2.getRecipientProjects)(state),
    recipientId: Number(ownProps.params.recipientId),
    recipientStatsLoading: state.statistics.recipientOverallStatsLoading,
    startDate: state.statistics.startDate
  };
}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(RecipientStatisticsOverall, _Component);

  function RecipientStatisticsOverall() {
    (0, _classCallCheck3.default)(this, RecipientStatisticsOverall);
    return (0, _possibleConstructorReturn3.default)(this, (RecipientStatisticsOverall.__proto__ || (0, _getPrototypeOf2.default)(RecipientStatisticsOverall)).apply(this, arguments));
  }

  (0, _createClass3.default)(RecipientStatisticsOverall, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var userId = nextProps.recipientId,
          startDate = nextProps.startDate,
          endDate = nextProps.endDate;

      var isDateChanged = startDate !== this.props.startDate || endDate !== this.props.endDate;
      if (isDateChanged && startDate && endDate) {
        this.props.loadRecipientOverallStats({ userId: userId, startDate: startDate, endDate: endDate });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          recipientStatsLoading = _props.recipientStatsLoading,
          globalStatsData = _props.globalStatsData,
          projects = _props.projects,
          recipientId = _props.recipientId,
          playStatsData = _props.playStatsData;
      var t = this.context.t;

      var chartOptions = { vAxis: { title: t('Number of plays / downloads') } };

      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.newComponent) },
        _react2.default.createElement(
          _Panel2.default,
          { className: styles.indent, title: t('Activity statistics') },
          _react2.default.createElement(_PlayStatsChart2.default, {
            id: 'recipientPlayStats',
            data: playStatsData,
            loading: recipientStatsLoading,
            chartOptions: chartOptions
          })
        ),
        _react2.default.createElement(
          _Panel2.default,
          { className: styles.indent, title: t('Global statistics on projects') },
          _react2.default.createElement(_DevicesChart2.default, {
            id: 'globalRecipientStats',
            data: globalStatsData,
            loading: recipientStatsLoading
          })
        ),
        _react2.default.createElement(
          'h4',
          null,
          t('Projects list')
        ),
        _react2.default.createElement(_StatisticsRecipientProjectsList2.default, {
          recipientId: recipientId,
          projects: projects,
          loading: recipientStatsLoading
        })
      );
    }
  }]);
  return RecipientStatisticsOverall;
}(_react.Component), _class2.propTypes = {
  endDate: _propTypes2.default.string,
  globalStatsData: _propTypes2.default.object,
  loadRecipientOverallStats: _propTypes2.default.func,
  playStatsData: _propTypes2.default.array,
  projects: _propTypes2.default.array,
  recipientId: _propTypes2.default.number,
  recipientStatsLoading: _propTypes2.default.bool,
  startDate: _propTypes2.default.string
}, _class2.contextTypes = {
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  globalStatsData: {},
  playStatsData: []
}, _temp)) || _class) || _class);
exports.default = RecipientStatisticsOverall;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Statistics/RecipientStatisticsOverall/RecipientStatisticsOverall.js
// module id = 2217
// module chunks = 1